import React from "react";
import { useLang } from "../i18n";

function Study() {
  const { t } = useLang();

  return (
    <section id="study" className="mt-20">
      <div className="section-label">
        <h2>{t.study.heading}</h2>
        <span>edu.json</span>
      </div>
      <ol className="study-list">
        {t.study.items.map((item) => (
          <li key={item.org} className="study-item">
            <span className="study-mark" aria-hidden="true" />
            <div>
              <p className="study-degree">{item.degree}</p>
              <p className="study-org">{item.org}</p>
            </div>
            <p className="study-place">{item.place}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}

export default Study;
